import { c as _c } from "react/compiler-runtime";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import { useProgramSearchParams } from "src/lib/program/useProgramSearchParams";
import { locale } from "@locale";
export function useShowCinemaFilter(isAdFree, adFreeSkin) {
  const $ = _c(5);
  const {
    firmId,
    theatre
  } = useProgramSearchParams();
  const {
    location
  } = useLocationContext();
  const cinemaFilterLocations = locale.program.cinemaFilterLocations;
  let t0;
  if ($[0] !== location) {
    t0 = location ?? [];
    $[0] = location;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = loc => cinemaFilterLocations.includes(loc);
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = t0.some(t2);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isCinemaFilterLocation = t1;
  return isCinemaFilterLocation && firmId === null && !theatre && !(isAdFree && adFreeSkin === "nfk");
}